import quotes from '../api/quotes'

export const state = {
  quotes: [],
  quote_pagination_data: {},
  quote: ''
}

export const getters = {
  quotes: state => state.quotes,
  quote_pagination_data: state => state.quote_pagination_data,
  quote: state => state.quote
}

export const mutations = {
  ADD_QUOTE (state, data) {
    state.quotes.push(data)
  },
  SET_QUOTES (state, data) {
    state.quotes = data
  },
  SET_QUOTE_PAGINATION (state, data) {
    state.quote_pagination_data = data
  },
  SHOW_QUOTE (state, data) {
    state.quote = data
  }
}

export const actions = {
  GET_QUOTES ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      quotes.get(data).then(response => {
        commit('SET_QUOTES', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_QUOTE_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_QUOTE ({ commit }, data) {
    return new Promise((resolve, reject) => {
      quotes.create(data).then(response => {
        commit('ADD_QUOTE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_QUOTE ({ commit }, id) {
    return new Promise((resolve, reject) => {
      quotes.show(id).then(response => {
        commit('SHOW_QUOTE', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  UPDATE_QUOTE ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      quotes.update(payload.data, payload.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_QUOTE ({ commit }, id) {
    return new Promise((resolve, reject) => {
      quotes.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/quotes.js